module.exports = __webpack_public_path__ + "img/index_kv01.a45e13ad.png";